import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Borrower } from 'app/modules/borrower/models/borrower/borrower.model';

// Remove this component upon the deprecation of Inbox
@Component({
  selector: 'app-message-threads-dialog',
  templateUrl: './message-threads-dialog.component.html',
  styleUrls: ['./message-threads-dialog.component.scss']
})
export class MessageThreadsDialogComponent implements OnInit {

  borrower: Borrower;

  constructor(
    public dialogRef: MatDialogRef<MessageThreadsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.borrower = this.data.borrower;
  }

}
